// extracted by mini-css-extract-plugin
export default {"users":"styles_users__49wG1","permissionActions":"styles_permissionActions__2ry8r"};